import { render, staticRenderFns } from "./BatchSetAdmin.vue?vue&type=template&id=385e38a2&scoped=true"
import script from "./BatchSetAdmin.vue?vue&type=script&lang=ts"
export * from "./BatchSetAdmin.vue?vue&type=script&lang=ts"
import style0 from "./BatchSetAdmin.vue?vue&type=style&index=0&id=385e38a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385e38a2",
  null
  
)

export default component.exports